export default "__VITE_ASSET__BjMYdS$H__"